import { render, staticRenderFns } from "./LeadMenu.vue?vue&type=template&id=085c7c8f&"
import script from "./LeadMenu.vue?vue&type=script&lang=js&"
export * from "./LeadMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports